<script setup lang="ts">
import { withDefaults } from 'vue';
import { useLocale } from '@/plugins/translation';
import type { BreadcrumbsStep } from '@ilteducation/videos';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

withDefaults(
  defineProps<{
    steps: BreadcrumbsStep[];
  }>(),
  {
    steps: () => [] as BreadcrumbsStep[],
  },
);

const { t, l } = useLocale();
</script>

<template>
  <ul class="breadcrumbs" :aria-label="t(l.label_breadcrumbs)">
    <li>
      <router-link :to="{ name: 'begreppaLanding' }" :title="t(l.home)">
        <FontAwesomeIcon icon="fa-regular fa-house"></FontAwesomeIcon>

        {{ t(l.home) }}
      </router-link>
    </li>
    <li v-for="(step, idx) in steps" :key="`${step.path}-${idx}`">
      <router-link :to="step.path">{{ step.name }}</router-link>
    </li>
  </ul>
</template>

<style scoped lang="scss">
@use '@/foundations/theme/settings';
@use 'sass:map';

.breadcrumbs {
  display: table;
  margin: 0;
  padding: 9px 0;

  li {
    display: table-cell;
    vertical-align: baseline;
    font:
      1rem/1.25 'filson-soft',
      Helvetica,
      Arial,
      sans-serif;
    color: rgba(var(--v-theme-on-surface-medium));

    white-space: nowrap;
    @media #{map.get(settings.$display-breakpoints, 'xs')} {
      font-size: 0.875rem;
      font-family: 'proxima-soft', Helvetica, Arial, sans-serif;
      font-weight: 400;
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    a {
      text-decoration: none;
      &:hover {
        color: rgba(var(--v-theme-on-surface)) !important;
      }
    }

    &:before {
      content: '/';
      display: inline-block;
      margin: 0 3px 0 4px;
    }

    &:first-child {
      &:before {
        content: '';
        position: relative;
        top: 3px;
        margin-left: 0;
      }
    }
  }
}
</style>
